import React from 'react';
import List from './list';
import request from '../../../service/request';
import { DECORATIONLIST_POST_LIST} from '../../../service/api';
async function action({ query,cookie, fetch }) {
    const params = Object.assign({
        "size": 20,
        "type": "2",
        "showStatus": 1,
        "page": 1
    },query);
    const [res] = await Promise.all([
        request.POST({
            url: DECORATIONLIST_POST_LIST,
            params,
            headers: cookie ? {
                cityCode: cookie['cityCode'] || 420200
            } : {}
        }),
    ]);
    const pageData = {
        list: res.data ? res.data.records : [],
        total: res.data.total,
        params
    }
    return {
        title: '东楚优房',
        chunks: ['elderlyRenovationList'],
        keywords: '东楚优房',
        description: '东楚优房',
        component: (
            <List pageData={pageData}  />
        )
    };
}


export default action;
